import axios from 'axios'

export const state = {
  kids: null,
}

export const getters = {
  kids: (state) => state.kids,
}

export const mutations = {
  SET_KIDS(state, kids) {
    state.kids = kids
  },
}

export const actions = {
  fetchAllKids({ commit }, payload) {
    return axios.get('/api/kids', { params: payload }).then((response) => {
      const kids = response.data
      commit('SET_KIDS', kids)
      return kids
    })
  },

  viewKid(_, id) {
    return axios.get(`/api/kids/${id}`).then(({ data }) => data)
  },

  createKid(_, payload) {
    return axios.post('/api/kids', payload)
  },

  updateKid(_, payload) {
    return axios.put(`/api/kids/${payload.id}`, payload)
  },

  deleteKid(_, kidId) {
    return axios.delete(`/api/kids/${kidId}`)
  },

  saveKidCount(_, { kid_id, date, count }) {
    return axios.post(`/api/kids/${kid_id}/counts`, { date, count })
  },
}
